import React, { useMemo, useState, useEffect, useRef } from "react";
import Transaction from "../../API/APIServices/Transaction";

const LensCreatedData1 = ({
  fetchLensPowerData,
  setItemsArray,
  combinedV,
  addValue,
  axisValue,
  TransAccountId,
  isReversed,
  isAddZero,
}) => {
  const [localData, setLocalData] = useState(fetchLensPowerData);
  const inputRefs = useRef([]);
  const [inputValues, setInputValues] = useState({});
  
  useEffect(() => {
    setLocalData(fetchLensPowerData);
  }, [fetchLensPowerData.length, axisValue]);

  const sphValues = useMemo(
    () => [...new Set(combinedV.map((item) => item.sph))],
    [combinedV]
  );
  const cylValues = useMemo(
    () => [...new Set(combinedV.map((item) => item.cyl))],
    [combinedV]
  );

  const rowCount = isAddZero ? sphValues.length : combinedV.length;
  const colCount = isAddZero ? cylValues.length : addValue.length;

  const filteredData = useMemo(() => {
    const map = new Map();
    const dataToUse = isReversed ? [...localData].reverse() : localData;

    dataToUse.forEach((item) => {
      const key = `${parseFloat(item.sph || "0.00").toFixed(2)}_${parseFloat(
        item.cyl || "0.00"
      ).toFixed(2)}_${parseFloat(item.axis || "0").toFixed(2)}_${parseFloat(
        item.add || "0.00"
      ).toFixed(2)}`;
      if (!map.has(key)) map.set(key, item);
    });

    return map;
  }, [localData, isReversed]);

  const handleKeyDown = (e, rowIndex, colIndex) => {
    let nextRow = rowIndex;
    let nextCol = colIndex;

    switch (e.key) {
      case "ArrowUp":
        nextRow = (rowIndex - 1 + rowCount) % rowCount;
        break;
      case "ArrowDown":
        nextRow = (rowIndex + 1) % rowCount;
        break;
      case "ArrowLeft":
        nextCol = (colIndex - 1 + colCount) % colCount;
        break;
      case "ArrowRight":
        nextCol = (colIndex + 1) % colCount;
        break;
      default:
        return;
    }

    const nextRefIndex = nextRow * colCount + nextCol;
    const nextInput = inputRefs.current[nextRefIndex];

    if (nextInput) {
      e.preventDefault();
      nextInput.focus();
      setTimeout(() => nextInput.select(), 0);
    }
  };

  const handleInputChange = async (e, item) => {
    const value = e.target.value;
    const isValidNumber = /^-?\d*\.?\d*$/.test(value);
    if (!isValidNumber) return;

    setInputValues((prev) => ({
      ...prev,
      [item.d2Id]: value,
    }));

    const filterData = {
      searchTypeId: 4,
      itmId_d2: item.d2Id,
    };

    const ItemDataByid =
      await Transaction.GetBarcodeSerialBatchNoForItemFetch(filterData);

    setItemsArray((prevArray) => {
      const existingIndex = prevArray.findIndex(
        (itm) => itm.d2_Id === ItemDataByid.d2_Id
      );

      if (existingIndex !== -1) {
        const updatedArray = [...prevArray];
        updatedArray[existingIndex] = {
          ...updatedArray[existingIndex],
          Qty: value,
        };
        return updatedArray;
      } else {
        const newRow = {
          d1_Id: ItemDataByid.d1_Id || "",
          d2_Id: ItemDataByid.d2_Id || "",
          productName: ItemDataByid.productName || "",
          parentGrp: ItemDataByid.parentGrp2 || "",
          parentGrpName: ItemDataByid.parentGrpName || "",
          productUnitName: ItemDataByid.productUnitName || "",
          productUnit: ItemDataByid.productUnit || "",
          productAltUnit: ItemDataByid.productAltUnit || "",
          unitConvFactor: ItemDataByid.unitConvFactor || "",
          enableBarcode: ItemDataByid.enableBarcode || "",
          defaultBarcode: ItemDataByid.Barcode || "",
          batchNos: ItemDataByid.batchDetails || [],
          taxCategory1: ItemDataByid.taxCategory1 || "",
          taxLimit: ItemDataByid.taxLimit || "",
          taxCategory2: ItemDataByid.taxCategory2 || "",
          hsnCode: ItemDataByid.hsnCode || "",
          shortDescription: "",
          Qty: e.target.value === 0 ? 1 : e.target.value || 1,
          FreeQty: ItemDataByid.FreeQty || "",
          purchasePrice: ItemDataByid.purchasePrice || "",
          purchaseDiscount: ItemDataByid.purchaseDiscount || "",
          saleProfit: ItemDataByid.saleProfit || "",
          salePrice: ItemDataByid.salePrice || "",
          saleDiscount: ItemDataByid.saleDiscount || "",
          itemPrice:
            Number(TransAccountId) === 216
              ? ItemDataByid.salePrice
              : Number(TransAccountId) === 215
              ? ItemDataByid.purchasePrice
              : ItemDataByid.salePrice,
          costPrice: ItemDataByid.costPrice || "",
          mrpPrice: ItemDataByid.mrpPrice || "",
          DiscPer:
            Number(TransAccountId) === 216
              ? ItemDataByid.saleDiscount
              : Number(TransAccountId) === 215
              ? ItemDataByid.purchaseDiscount
              : ItemDataByid.saleDiscount,
          DiscAmt: ItemDataByid.DiscAmt || "",
          TotalAmt: ItemDataByid.TotalAmt || "",
          purPageSalePrice: ItemDataByid.salePrice || "",
          availableQuantity: ItemDataByid.availableQuantity || "",
          lens_Eye: ItemDataByid.lens_Eye || "",
          lens_SPH: ItemDataByid.lens_SPH || "",
          lens_CYL: ItemDataByid.lens_CYL || "",
          lens_AXIS: ItemDataByid.lens_AXIS || "",
          lens_Dia: ItemDataByid.lens_Dia || "",
          lens_Add: ItemDataByid.lens_Add || "",
          enableSerialNo: ItemDataByid.enableSerialNo || "",
          taxCat1_Cgst: ItemDataByid.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemDataByid.taxCat1_Sgst || "",
          taxCat1_Igst: ItemDataByid.taxCat1_Igst || "",
          taxCat1_Cess: ItemDataByid.taxCat1_Cess || "",
          taxCat2_Cgst: ItemDataByid.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemDataByid.taxCat2_Sgst || "",
          taxCat2_Igst: ItemDataByid.taxCat2_Igst || "",
          taxCat2_Cess: ItemDataByid.taxCat2_Cess || "",
          rowIndex: 0,
        };
        return [...prevArray, newRow];
      }
    });
  };

  inputRefs.current = [];

  return (
    <tbody>
      {isAddZero
        ? (isReversed ? [...sphValues].reverse() : sphValues).map((sphValue, rowIndex) => (
            <tr className="TrLensCreation" key={`sph-${rowIndex}`}>
              <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1">
                {sphValue}
              </td>
              { (isReversed ? [...cylValues].reverse() : cylValues).map((cylValue, colIndex) => {
                const key = `${parseFloat(sphValue || "0").toFixed(
                  2
                )}_${parseFloat(cylValue || "0").toFixed(2)}_${parseFloat(
                  axisValue || "0"
                ).toFixed(2)}_0.00`;
                const item = filteredData.get(key);
                if (!item)
                  return (
                    <td className="tableData rows_indicator" key={colIndex}>
                      <input
                        className="tableBox"
                        type="text"
                        disabled
                        value="-"
                        style={{
                          background: "rgb(247 247 247)",
                          textAlign: "center",
                        }}
                      />
                    </td>
                  );

                const refIndex = rowIndex * colCount + colIndex;
                const inputValue = inputValues[item.d2Id] || "";

                return (
                  <td className="tableData rows_indicator" key={colIndex}>
                    <input
                      className="tableBox"
                      type="text"
                      value={inputValue}
                      onChange={(e) => handleInputChange(e, item)}
                      ref={(el) => {
                        if (el) inputRefs.current[refIndex] = el;
                      }}
                      onKeyDown={(e) =>
                        handleKeyDown(e, rowIndex, colIndex)
                      }
                    />
                  </td>
                );
              })}
            </tr>
          ))
        : (isReversed ? [...combinedV].reverse() : combinedV).map(
            (data, rowIndex) => {
              let firstValidItem = null;
              for (let val of addValue) {
                const key = `${parseFloat(data.sph || "0.00").toFixed(
                  2
                )}_${parseFloat(data.cyl || "0.00").toFixed(
                  2
                )}_${parseFloat(data.axis || "0").toFixed(2)}_${parseFloat(
                  val || "0.00"
                ).toFixed(2)}`;
                const item = filteredData.get(key);
                if (item) {
                  firstValidItem = item;
                  break;
                }
              }

              return (
                <tr className="TrLensCreation" key={rowIndex}>
                  {firstValidItem && (
                    <>
                      <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1">
                        {firstValidItem.sph}
                      </td>
                      <td className="firstColumnCellStyle tableData rows_indicator ButtonStick2">
                        {firstValidItem.cyl}
                      </td>
                      <td className="firstColumnCellStyle tableData rows_indicator ButtonStick">
                        {firstValidItem.axis || "--"}
                      </td>
                    </>
                  )}

                  {addValue.map((value4, colIndex) => {
                    const key = `${parseFloat(data.sph || "0.00").toFixed(
                      2
                    )}_${parseFloat(data.cyl || "0.00").toFixed(
                      2
                    )}_${parseFloat(data.axis || "0").toFixed(2)}_${parseFloat(
                      value4 || "0.00"
                    ).toFixed(2)}`;
                    const item = filteredData.get(key);
                    if (!item) return <td key={colIndex}></td>;

                    const refIndex = rowIndex * colCount + colIndex;
                    const inputValue = inputValues[item.d2Id] || "";

                    return (
                      <td className="tableData rows_indicator" key={colIndex}>
                        <input
                          className="tableBox"
                          type="text"
                          value={inputValue}
                          onChange={(e) => handleInputChange(e, item)}
                          ref={(el) => {
                            if (el) inputRefs.current[refIndex] = el;
                          }}
                          onKeyDown={(e) =>
                            handleKeyDown(e, rowIndex, colIndex)
                          }
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            }
          )}
    </tbody>
  );
};

export default LensCreatedData1;
